import React from 'react';
import { useSelector } from 'react-redux';
import { translate } from '../../../../../common/intl';
import { companyActions, companySelectors } from '../../../../../state/ducks/company';
import { Company } from '../../../../../state/ducks/company/types';
import useActionCreator from '../../../../hooks/useActionCreator';
import useAsync from '../../../../hooks/useAsync';
import DisplayComponent from '../../components/Display';
import EditingComponent from '../../components/Editing';
import SettingsPanel from '../../components/Panels';
import { SettingsPanelProps } from '../../types';

const ApprovalRequestsSettingsPanel: React.FC<SettingsPanelProps> = (props) => {
  const companyNameValue = useSelector(companySelectors.companyNameSelector);
  const [companyName, setCompanyName] = React.useState(companyNameValue);
  const [isEditing, setIsEditing] = React.useState(false);

  const async = useAsync({
    onSuccess: (values?: Company) => {
      setCompanyName(values?.name ?? '');
    },
    onError: () => {
      setCompanyName(companyNameValue);
    },
  });
  const changeCompanyAction = useActionCreator(companyActions.updateCompanyMine);

  React.useEffect(() => {
    setCompanyName(companyNameValue);
  }, [companyNameValue]);

  const onEdit = () => {
    setIsEditing(!isEditing);
  };

  const onSave = () => {
    async.start(changeCompanyAction, { name: companyName }, async);
    setIsEditing(false);
  };

  const onChange = (address: string) => {
    setCompanyName(address);
  };

  return (
    <SettingsPanel {...props} title={translate('administration.company.information.panel.title.name')}>
      {isEditing ? (
        <EditingComponent
          {...{ onSave, onChange }}
          value={companyName}
          onCancel={onEdit}
        />
      ) : (
      <DisplayComponent displayValue={companyName} {...{ onEdit }} />
      )}
    </SettingsPanel>
  );
};

export default ApprovalRequestsSettingsPanel;
